<script lang="ts">
	import { Separator } from '$lib/ui-woltair/components'

	export let investors: Object
</script>

{#if investors?.logos.length}
	<section class="page-wrapper flex flex-col items-center border-b-2 border-neutral-200 pb-20 pt-6">
		<Separator />

		<h2 class="max-w-4xl text-center">{investors?.title}</h2>

		<div class="my-8 flex min-h-12 w-full flex-wrap justify-center gap-x-20">
			{#each investors?.logos as logo}
				<img
					src={logo?.url}
					alt={logo?.alt}
					class="my-4 object-contain lg:my-0 {logo?.cls}"
					loading="lazy"
				/>
			{/each}
		</div>

		<p class="max-w-5xl text-center text-base text-neutral-600">{investors?.subtext}</p>
	</section>
{/if}
